import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AdminComponent } from './admin/admin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuard } from './service/auth.guard';
import { NavComponent } from './nav/nav.component';
import {NgbModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import { NgSelect2Module } from 'ng-select2';
import { MatTableModule, MatPaginatorModule, MatProgressSpinnerModule, MatCardModule, MatDatepickerModule, MatDatepicker, MatDialogModule, MatStepperModule, MatSelectModule, MatCheckbox, MatCheckboxModule } from '@angular/material';
import { DatePipe } from '@angular/common';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { AdmissionComponent } from './scholarship/admission/admission.component';
import { DonarComponent } from './scholarship/donar/donar.component';
import { DonatefundComponent } from './scholarship/donatefund/donatefund.component';
import { FeesPaymentComponent } from './scholarship/fees-payment/fees-payment.component';
import { PaymentListComponent, DialogReceipt } from './scholarship/payment-list/payment-list.component';
import { AdoptListComponent } from './scholarship/adopt-list/adopt-list.component';
import { StudentListComponent, DialogDataExampleDialog } from './scholarship/student-list/student-list.component';
import { AdoptComponent } from './scholarship/adopt/adopt.component';
import { ExpenseComponent } from './scholarship/expense/expense.component';
import { ExpenseListComponent } from './scholarship/expense-list/expense-list.component';
import { DueListComponent } from './scholarship/due-list/due-list.component';
import { OldStudentComponent } from './scholarship/old-student/old-student.component';
import { RefundListComponent, DialogOldStudent } from './scholarship/refund-list/refund-list.component';
import { DonarListComponent, DialogDonar, confirmDialog } from './scholarship/donar-list/donar-list.component';
import { ScholarshipRefundComponent } from './scholarship/scholarship-refund/scholarship-refund.component';
import { ExpenseMasterComponent } from './master/expense-master/expense-master.component';
import { StudentPaymentComponent } from './scholarship/student-payment/student-payment.component';
import { RefundComponent } from './scholarship/refund/refund.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdminComponent,
    NavComponent,
    DashboardComponent,
    UserDashboardComponent,
    UpdatePasswordComponent,
    AdmissionComponent,
    DonarComponent,
    DonatefundComponent,
    FeesPaymentComponent,
    PaymentListComponent,
    AdoptListComponent,
    StudentListComponent,
    AdoptComponent,
    ExpenseComponent,
    ExpenseListComponent,
    DueListComponent,
    OldStudentComponent,
    RefundListComponent,
    DonarListComponent,
    ScholarshipRefundComponent,
    DialogDataExampleDialog,
    DialogDonar,
    DialogReceipt,
    ExpenseMasterComponent,
    StudentPaymentComponent,
    RefundComponent,
    confirmDialog,
    DialogOldStudent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    NgSelect2Module,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatDatepickerModule,
    NgbTypeaheadModule,
    MatDialogModule,
    MatStepperModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSelectModule,
    MatCheckboxModule

  ],
  providers: [
    AuthGuard,
    DatePipe
  ],
  bootstrap: [AppComponent],
  entryComponents:[DialogDataExampleDialog,DialogDonar,DialogReceipt,confirmDialog,DialogOldStudent]
})
export class AppModule { }
